import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DownArrow = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15 3V26.4L7.737 18.337C7.549 18.137 7.287 18 7 18C6.45 18 6 18.45 6 19C6 19.262 6.1 19.488 6.263 19.663L15.263 29.663C15.451 29.875 15.726 29.988 16.001 29.988C16.276 29.988 16.551 29.863 16.739 29.663L25.739 19.663C25.902 19.488 26.001 19.25 26.001 19C26.001 18.45 25.551 18 25.001 18C24.701 18 24.438 18.125 24.263 18.337L17.001 26.4V3C17.001 2.45 16.551 2 16.001 2C15.451 2 15.001 2.45 15.001 3H15Z" />
	</svg>
);

export default DownArrow;
